import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export const Wrapper = ({ children, className = '', scrollY = false }) => (
  <div className={`${classes.wrapper} ${scrollY ? classes.scrollY : ''} ${className}`.trim()}> {children} </div>
)

Wrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  scrollY: PropTypes.bool,
}
